import React from "react";

export default function Decline(props) {
  return <h2 className="text-center pt-4">You Declined</h2>;
}
